import { useMemo } from 'react'

import { IPluginBackendAction, IPluginDataField } from '@makyoapp/makyo-sdk/models/Plugins'
import { PluginAdapter } from '@makyoapp/makyo-common'

import { fromSdkPluginList } from '@/adapters/PluginAdapter'
import { useGetPlugins } from '@/resolvers/plugin/query'

export type PluginActionField = IPluginDataField
type PluginAction = IPluginBackendAction & {
  icon: string
}

export interface PluginWithActions {
  id: string
  name: string
  actions: PluginAction[]
  pluginDetail: PluginAdapter
}

export function usePluginActions() {
  // get all plugins
  const { data, isLoading, error } = useGetPlugins({
    categories: [],
  })

  // filter plugins that have backend actions
  const pluginActions = useMemo(() => {
    if (!data?._Data) return []

    return data._Data
      .filter((plugin) => plugin._BackendActions && plugin._BackendActions.length > 0)
      .map((plugin) => {
        // Convert plugin to PluginAdapter format using fromSdkPluginList
        const [pluginAdapter] = fromSdkPluginList([plugin])
        return {
          id: plugin._id,
          name: plugin._Name,
          actions: plugin._BackendActions.map((action) => ({
            ...action,
            icon: pluginAdapter.icon,
          })),
          pluginDetail: pluginAdapter,
        }
      })
  }, [data])

  return {
    pluginActions,
    loading: isLoading,
    error: error || null,
  }
}
